import React, { useContext } from "react";
import WithLoader from "./WithLoader";
import AppContext from "../contexts/AppContext";
import BannerArea1 from "./BannerArea1";

function MainBannerApprovalArea1({ children, setLoading }) {
  const { context, setContext } = useContext(AppContext);

  let menuList =
    context?.pageConfig?.subcomponents[0]?.subcomponents[0]?.subcomponents[0];
  return (
    <div className="lg:px-8 px-4 pb-8 pt-4 lg:pt-8 w-rb overflow-auto">
      <BannerArea1 {...menuList} setLoading={setLoading} />
      <div className="pt-4 block h-full">{children}</div>
    </div>
  );
}

export default WithLoader(MainBannerApprovalArea1);
